export default __webpack_public_path__ + "static/media/apr-22.47562297.jpg";